
import React, {FC} from 'react';
import classNames from 'classnames';
import {BG} from 'constants/index';

import * as styles from './styles.module.scss';

type VideoProps = {
	src: string
	poster: string
	title: string
	description: string
	bg?: BG
}

const Video: FC<VideoProps> = ({
	src, poster, title, description,
	bg = BG.transparent,
}) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.video}>
				<video
					src={src}
					poster={poster}
					autoPlay
					loop
					muted
					playsInline
				/>
				<div className={classNames({
					[styles.text]: true,
					[styles.transparent]: bg === BG.transparent,
					[styles.dark]: bg === BG.dark,
					[styles.light]: bg === BG.light,
				})}>
					<span className={styles.title}>{title}</span>
					<span className={styles.description}>{description}</span>
				</div>
			</div>
		</div>
	);
};

export default Video;
